const i18n = require('i18n');
const CaseFilter = cc.Enum({
    NONE: 1,
    LOWER_CASE: 2,
    UPPER_CASE: 3,
    FIRST_LETTER_UP_REST_LOW: 4
});

const LocalizedLabelOption = cc.Class({
    name: 'LocalizedLabelOption',
    properties: {
        key: '',
        value: '',
        advanced: false,
        useLaunchParamValue: {
            default: false,
            visible: function() { return this.advanced; }
        },
        launchParamName: {
            default: '',
            visible: function() { return this.useLaunchParamValue; }
        },
        prefix: {
            default: '',
            visible: function() { return this.useLaunchParamValue; }
        },
        suffix: {
            default: '',
            visible: function() { return this.useLaunchParamValue; }
        }
    }
});

cc.Class({
    extends: cc.Label,

    properties: {
        options: {
            default: [],
            type: LocalizedLabelOption,
            notify: function() {
                if (this._sgNode) {
                    this._sgNode.setString(this.string);
                    this._updateNodeSize();
                }
                this.setVertsDirty();
                this._checkStringEmpty();
            },
            animatable: false
        },
        caseFilter: {
            default: CaseFilter.NONE,
            type: CaseFilter,
            notify: function() {
                if (this._sgNode) {
                    this._sgNode.setString(this.string);
                    this._updateNodeSize();
                }
                this.setVertsDirty();
                this._checkStringEmpty();
            },
            animatable: false
        },
        textKey: {
            default: 'TEXT_KEY',
            multiline: true,
            tooltip: 'Enter i18n key here',
            notify: function () {
                if (this._sgNode) {
                    this._sgNode.setString(this.string);
                    this._updateNodeSize();
                }
                this.setVertsDirty();
                this._checkStringEmpty();
            }
        },
        string: {
            override: true,
            tooltip: 'Here shows the localized string of Text Key',
            get: function () {

                let opt;
                if (this.options && this.options.length) {
                    opt = {};

                    this.options.forEach( option => {
                        if (option.useLaunchParamValue && !CC_EDITOR) {
                            if (window &&
                                window.PSGames &&
                                window.PSGames.launchParams &&
                                window.PSGames.launchParams[option.launchParamName])
                            {
                                option.value = option.prefix +
                                window.PSGames.launchParams[option.launchParamName] +
                                option.suffix;
                            }
                        }
                        opt[option.key] = option.value
                    });
                }
                let text = i18n.t(this.textKey, opt);

                switch (this.caseFilter) {
                    case CaseFilter.UPPER_CASE:
                        text = text.toUpperCase();
                        break;
                    case CaseFilter.LOWER_CASE:
                        text = text.toLowerCase();
                        break;
                    case CaseFilter.FIRST_LETTER_UP_REST_LOW:
                        const c = text[0];
                        const r = text.slice(1)
                        text = c.toUpperCase() + r.toLowerCase();
                        break;
                }
                return text;
            },
            set: function (value) {
                cc.warn('Please set label text key in Text Key property.');
            }
        },
    }
});
